import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { StyledSidemenuItem } from "../../styles/StyledSidemenu";
import AddIcon from "../../assets/img/icons/add.svg";

const addPaths = [
	{ when: "/decisions", path: "/add-decision" },
	{ when: "/units", path: "/add-unit" },
	{ when: "/meetings", path: "/add-meeting" },
];

export default function SidemenuItem({ item }) {
	const location = useLocation();

	if (addPaths.find((add) => add.when === item.path)) {
		return (
			<StyledSidemenuItem
				active={location.pathname === item.path ? true : false}
				data-testid={location.pathname === item.path ? "active" : undefined}
			>
				<Link to={item.path}>{item.name}</Link>
				<Link to={addPaths.find((add) => add.when === item.path).path}>
					<img src={AddIcon} alt="add" />
				</Link>
			</StyledSidemenuItem>
		);
	}
	return (
		<StyledSidemenuItem
			active={location.pathname === item.path ? true : false}
			data-testid={location.pathname === item.path ? "active" : undefined}
		>
			<Link to={item.path}>{item.name}</Link>
		</StyledSidemenuItem>
	);
}

SidemenuItem.propTypes = {
	item: PropTypes.object,
};
